export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8846.5d431d12.jpg";